/** Actions */
export const ON_FETCH_CONTRIBUTORS = 'ON_FETCH_CONTRIBUTORS';
export const ON_FETCH_CONTRIBUTORS_SUCCESS = 'ON_FETCH_CONTRIBUTORS_SUCCESS';
export const ON_FETCH_CONTRIBUTORS_FAILURE = 'ON_FETCH_CONTRIBUTORS_FAILURE';

/** Action creators */

export function onFetchContributors() {
  return { type: ON_FETCH_CONTRIBUTORS };
}

export function onFetchContributorsSuccess(user: any, repos: any) {
  return { type: ON_FETCH_CONTRIBUTORS_SUCCESS, user, repos };
}

export function onFetchContributorsFailure() {
  return { type: ON_FETCH_CONTRIBUTORS_FAILURE };
}
